import { createTheme } from '@mui/material/styles';

// ##############################
// // // Global Theme Variables
// #############################

const colors = {
    colorprimary100: '#375837',    
    colorprimary80: '#456E45', 
    colorprimary60: '#639E63',
    colordanger100: '#7F1D1D',     
    colordanger80: '#DC2626',
    colordanger60: '#CC4056',
    colorsuccess80: '#38754D',
    colorsuccess20: '#E3F3E7',
    colorblack: '#2E2B2B',
    colorwhite: '#fff',
    colorgrey20: '#EFEFF0',
    colorgrey40: '#E6E3E3',
    colorgrey60: '#B8B6B6'  
}

const fonts = {
    // Font family
    fontprimary: '"OpenSans-Regular", Helvetica, Roboto, Arial, sans-serif',
    fontbold: '"OpenSans-Bold", Helvetica, Roboto, Arial, sans-serif',
    fontsemibold: '"OpenSans-SemiBold", Helvetica, Roboto, Arial, sans-serif',

    // Font sizes
    fontsizebody: '16px',
    fontsizesmall: '14px',
};

export {
    colors,
    fonts
}

const theme = createTheme({
    palette: {
        type: 'light',
        background: {
            default: '#F7F7F7',
            paper: '#FFFFFF',
        },
        primary: {
            main: '#40A020',
            light: '#CC4056',
            dark: '#008000',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#74748F',
            light: '#A2A2BB',
            dark: '#535470',
        },
        error: {
            main: '#FF4000',
            light: '#FFEDF0',
            dark: '#8C0017',
        },
        warning: {
            main: '#FFD000',
            light: '#FFF6E8',
            dark: '#80591E',
        },
        success: {
            main: '#40A020',
            light: '#E3F3E7',
            dark: '#38754D',
        },
        text: {
            primary: '#404040',
            secondary: '#787575',
            disabled: '#B8B6B6',
        },
    },
    typography: {
        fontFamily: fonts.fontprimary,
        fontSize: 16,
        h1: {
            fontSize: '40px',
            lineHeight: '52px',
            letterSpacing: '0',
        },
        h2: {
            fontSize: '28px',
            lineHeight: '40px',
            letterSpacing: 0,
        },
        h3: {
            fontSize: '22px',
            lineHeight: '32px',
            letterSpacing: 0,
        },
        h4: {
            fontSize: '18px',
            lineHeight: '28px',
            letterSpacing: 0,
            fontFamily: fonts.fontprimary,
        },
        h5: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontFamily: fonts.fontbold,
        },
        body1: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        body2: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        caption: {
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: 0,
        },
        overline: {
            fontSize: '12px',
            lineHeight: '20px',
            letterSpacing: '1.5px',
        },
    }
});

export default theme;

